import React from "react";

const Banco = (props) => {
    return(
    <div className="">
    <h2>Banco condensadores</h2>
    <span>
    Beneficios del uso de Banco de Condensadores
    <li>No pagar energía reactiva al suministrador de energía eléctrica / reduciendo el valor total de la factura mensual de energía
    </li>
    <li>Disminuye las pérdidas de la red eléctrica por calentamientos en sus componentes.
    </li>
    <li>Aumenta la vida útil de sus equipos y maquinarias.
    </li>
    <li>Disminuir caídas de tensión.
    </li>
    <li>Minimizar pérdidas de energía.
    </li>
    <li>Ampliar la capacidad de transmisión de potencia activa en los cables.
    </li>
    <li>El beneficio más obvio es el ahorro de costes, ya que al tomar usted medidas para reducir su demanda eléctrica, conseguirá una reducción de su factura eléctrica.
    </li>
    <li>También mejora el voltaje en su instalación: con la compensación de energía reactiva circula menos corriente por los cables, por lo que estos tienen menos caída de tensión, y mejora la tensión que llega a los equipos.
    </li>
    </span>
    </div>
  );
}

export {Banco}